export enum SideItemOption {
    BACKSPLASH = 'backsplash',
    WATERFALL = 'waterfall',
}
